<div class="theme-container">
  <div class="theme-container-inner">
    <!-- Page Breadcrumb Start -->
    <div class="breadcrumb-main">
        <snl-breadcrumb>
          <div left-side> 
            <h1 class="header-h1 fw-700 color__primary">{{this.fleet}} Dashboard</h1>
          </div>
          <!-- <div right-side>
            <span>Last update: <strong class="color__primary fw-700" *ngIf="latestUpdate">{{latestUpdate | date:'d MMM y'}}</strong></span>
          </div> -->
        </snl-breadcrumb>
    </div>
    <!-- Page Breadcrumb End -->


    <!-- Container Card Start -->
    <div class="CommonContainerCard border-body-tbl border__radius8">
      <div class="contentSec p-0" id="hightchart"> 
       <app-dashboard-chart></app-dashboard-chart>
      </div>
    </div>
    <!-- Container CardEnd  -->
  </div>
</div>